module.exports = __webpack_public_path__ + "img/nav-tick.c0a59c7b.svg";